/**
 * @desc 保存
 */
import { DictEntity, DictForm } from '@eastcoal/api/system/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateDictParameter = DictForm

const method = 'POST'
const url = '/system/dict'

export const createDictApi = (
  data?: CreateDictParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<DictEntity>({
    method,
    url,
    data,
    ...config
  })
}

createDictApi.method = method
createDictApi.url = url
